<lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>

<div class="text-lg mb-5 font-semibold text-gray-800">{{currentScreenType?'Court Staff Registration':'Parties'}}</div>

<form class="bg-fieldset py-4 px-4 mb-3 rounded-lg shadow-sm border border-gray-200" [formGroup]="searchFormGrp">
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-end">

    <div class="flex flex-col">
      <mat-label class="mb-1 text-sm font-medium">{{currentScreenType?'ID':'Party ID'}}</mat-label>
      <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
        <input matInput type="text" formControlName="partyId" placeholder="Enter Party ID" class="text-sm" />
        <button mat-icon-button matSuffix (click)="searchHandler('party-Id',false)" aria-label="Search">
          <mat-icon>search</mat-icon>
        </button>

      </mat-form-field>
    </div>

    <div class="flex flex-col">
      <mat-label class="mb-1 text-sm font-medium">{{currentScreenType?'Name':'Party Name'}}</mat-label>
      <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
        <input matInput type="text" formControlName="partyName" placeholder="Enter Party Name" class="text-sm"
          [value]="searchFormGrp.get('caseNumber')?.value || ''" />
        <button mat-icon-button matSuffix (click)="searchHandler('party-name',false)" aria-label="Search">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="flex items-center pb-1">
      <button type="reset" mat-stroked-button color="primary" class="w-full sm:w-auto mt-5"
        (click)="resetHandler()">Reset</button>
    </div>
  </div>
</form>

<div *ngIf="isLoading()" class="flex justify-center my-6">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<div class="p-4 border rounded-lg bg-fieldset mt-2 mb-5 shadow-sm" *ngIf="!isLoading()">

  <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
    <h3 class="text-lg font-semibold m-0">{{currentScreenType?'Court Staff Details':'Parties'}}</h3>

    <div class="flex flex-wrap gap-2 w-full sm:w-auto justify-start sm:justify-end">
      <button mat-flat-button color="primary" class="action-button" *ngIf="partiesData() === null && !isAdd"
        (click)="toggleAdd()">
        <mat-icon>add</mat-icon> Add
      </button>

      <button mat-flat-button color="primary" class="action-button" *ngIf="partiesData()!==null && !isEditing"
        (click)="toggleEdit()" [disabled]="isDashboard">
        <mat-icon>edit</mat-icon> Edit
      </button>

      <button mat-flat-button color="primary" class="action-button" *ngIf="isEditing || isAdd" (click)="handleSave()">
        <mat-icon>save</mat-icon> Save
      </button>

      <button mat-stroked-button color="warn" class="action-button" *ngIf="isEditing" (click)="cancelEdit()">
        <mat-icon>cancel</mat-icon> Cancel
      </button>

      <button mat-stroked-button color="warn" class="action-button" *ngIf="isAdd" (click)="cancelAdd()">
        <mat-icon>cancel</mat-icon> Cancel
      </button>
    </div>
  </div>

  <div class="border-b my-2" *ngIf="partiesData() || isAdd"></div>

  <form [formGroup]="partyForm" class="space-y-4 mt-4" *ngIf="partiesData() || isAdd">

    <div class="flex flex-col sm:flex-row sm:items-center gap-4 mb-4">
      <mat-radio-group formControlName="partyType" class="flex flex-wrap gap-4" [disabled]="!isAdd"
        (change)="onPartyTypeChange($event)">
        <mat-radio-button value="PERSON" *ngIf="!currentScreenType">Person</mat-radio-button>
        <mat-radio-button value="CORPORATE" *ngIf="!currentScreenType">Corporate</mat-radio-button>
        <mat-radio-button value="GROUP" *ngIf="!currentScreenType">Group</mat-radio-button>
        <mat-radio-button value="GOVT" *ngIf="!currentScreenType">Govt</mat-radio-button>
        <mat-radio-button value="COURTSTAFF" *ngIf="currentScreenType">Court Staff</mat-radio-button>
      </mat-radio-group>

      <div class="sm:ml-auto flex items-center bg-green-50 px-3 py-1 rounded border border-green-200"
        *ngIf="partiesData()?.partiesId">
        <label class="mr-2 font-semibold text-sm text-green-800">Party ID:</label>
        <span class="text-green-900 text-sm font-bold">{{ partiesData()?.partiesId }}</span>
      </div>
    </div>

    <div [ngClass]="gridClass">
      <ng-container *ngIf="(selectedPartyType === 'PRS') ||(selectedPartyType === 'CST' && currentScreenType)">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
          <div class="w-full" *ngIf="!partiesData()?.partiesId && currentScreenType">
            <label class="block font-medium text-sm mb-1">
              <span class="text-red-500">*</span>{{'Staff Id'}}
            </label>

            <mat-form-field class="w-full" appearance="outline">
              <span matPrefix class="staff-prefix">{{courtStaffcode}}<span class="divider"></span></span>

              <input matInput type="text" maxLength="8" formControlName="staffid" placeholder="Enter Staff ID" />

              <mat-error
                *ngIf="partyForm.get('staffid')?.hasError('required') && (partyForm.get('staffid')?.touched || partyForm.get('staffid')?.dirty)">
                Staff ID is required
              </mat-error>

              <mat-error
                *ngIf="partyForm.get('staffid')?.hasError('pattern') && (partyForm.get('staffid')?.touched || partyForm.get('staffid')?.dirty)">
                Only numeric digits are allowed
              </mat-error>
            </mat-form-field>
          </div>
          <ng-container *ngFor="let field of filteredPersonFields">
            <div class="w-full">
              <label class="block font-medium text-sm mb-1">
                <ng-container *ngIf="isRequired(field.name); else normalLabel">
                  <span class="text-red-500">*</span>{{ field.label }}
                </ng-container>
                <ng-template #normalLabel>{{ field.label }}</ng-template>
              </label>

              <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                <ng-container [ngSwitch]="field.name">
                  <ng-container *ngSwitchCase="'dateOfBirth'">
                    <input matInput [matDatepicker]="picker" [formControlName]="field.name" [max]="todayDate" />
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </ng-container>

                  <ng-container *ngSwitchCase="'gender'">
                    <mat-select [formControlName]="field.name" [compareWith]="compareGender">
                      <mat-option value="Male">Male</mat-option>
                      <mat-option value="Female">Female</mat-option>
                      <mat-option value="Others">Others</mat-option>
                    </mat-select>
                  </ng-container>

                  <ng-container *ngSwitchCase="'email'">
                    <input matInput type="email" [formControlName]="field.name" (input)="onEmailInput($event)"
                      placeholder="example@domain.com" />

                    <mat-error
                      *ngIf="partyForm.get(field.name)?.hasError('email') && (partyForm.get(field.name)?.touched || partyForm.get(field.name)?.dirty)">
                      Please enter a valid email
                    </mat-error>
                    <mat-error
                      *ngIf="partyForm.get(field.name)?.hasError('required') && (partyForm.get(field.name)?.touched || partyForm.get(field.name)?.dirty)">
                      Email is required
                    </mat-error>
                  </ng-container>

                  <ng-container *ngSwitchCase="'idType'">
                    <mat-select [formControlName]="field.name" (selectionChange)="handleIdTypeChange($event.value)">
                      <mat-option *ngFor="let option of idTypes" [value]="option">{{ option.name }}</mat-option>
                    </mat-select>
                  </ng-container>

                  <ng-container *ngSwitchCase="'idNumber'">
                    <input matInput [formControlName]="field.name" />
                    <mat-error
                      *ngIf="partyForm.get(field.name)?.hasError('required') && (partyForm.get(field.name)?.touched || partyForm.get(field.name)?.dirty)">
                      ID Number is required
                    </mat-error>
                  </ng-container>

                  <ng-container *ngSwitchCase="'mobileNumber'">
                    <input matInput type="tel" maxlength="20" [formControlName]="field.name"
                      (input)="onMobileInputNoFormat(-1)" (keypress)="allowOnlyNumbersAndDash($event)" />
                    <mat-error *ngIf="mobileCtrl?.hasError('pattern')">
                      Format: 0XXX-XXX-XXXX (11 digits)
                    </mat-error>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <input matInput [formControlName]="field.name" [type]="field.type || 'text'" />
                  </ng-container>
                </ng-container>
                <mat-error *ngIf="partyForm.get(field.name)?.hasError('required')">
                  {{ field.label }} is required
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <div *ngIf="selectedPartyType === 'CRE'" class="flex flex-col lg:flex-row w-full gap-4">
        <!-- Name Field -->
        <div class="w-full lg:w-1/3">
          <mat-label class="block mb-1 text-sm font-medium"><span class="text-red-500">*</span> Name</mat-label>
          <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
            <input matInput formControlName="name" />
          </mat-form-field>
        </div>

        <!-- ID Type Dropdown -->
        <div class="w-full lg:w-1/3">
          <mat-label class="block mb-1 text-sm font-medium">ID Type</mat-label>
          <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
            <mat-select formControlName="idType" (selectionChange)="handleIdTypeChange($event.value)">
              <mat-option *ngFor="let option of idTypes" [value]="option">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- ID Number Input -->
        <div class="w-full lg:w-1/3">
          <mat-label class="block mb-1 text-sm font-medium"><span class="text-red-500">*</span> ID Number</mat-label>
          <mat-form-field class="w-full" appearance="outline">
            <input matInput formControlName="idNumber" />
            <mat-error
              *ngIf="partyForm.get('idNumber')?.hasError('required') && (partyForm.get('idNumber')?.touched || partyForm.get('idNumber')?.dirty)">
              ID Number is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div *ngIf="selectedPartyType === 'GRP'" class="flex flex-col lg:flex-row w-full gap-6">
        <div class="w-full lg:w-2/5">
          <mat-label class="block mb-1 text-sm font-medium"><span class="text-red-500">*</span> Group Name</mat-label>
          <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
            <input matInput formControlName="groupName" />
          </mat-form-field>
        </div>

        <div class="w-full lg:w-3/5 border rounded-md p-4 shadow-sm bg-white">
          <form [formGroup]="searchFormGrp1">
            <div class="flex flex-wrap items-end gap-3 mb-3">
              <div class="flex-1 min-w-[140px]">
                <mat-label class="text-xs">Party ID</mat-label>
                <mat-form-field class="w-full text-sm" appearance="outline" subscriptSizing="dynamic">
                  <input matInput type="text" formControlName="partyId" [disabled]="!isEditing && !isAdd" />
                  <button mat-icon-button matSuffix (click)="searchHandler('party-Id',true)"
                    [disabled]="!isEditing && !isAdd">
                    <mat-icon>search</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <div class="flex-1 min-w-[140px]">
                <mat-label class="text-xs">Party Name</mat-label>
                <mat-form-field class="w-full text-sm" appearance="outline" subscriptSizing="dynamic">
                  <input matInput type="text" formControlName="partyName" [disabled]="!isEditing && !isAdd" />
                  <button mat-icon-button matSuffix (click)="searchHandler('party-name',true)"
                    [disabled]="!isEditing && !isAdd">
                    <mat-icon>search</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <div>
                <button class="px-3 py-2 rounded text-white text-sm font-medium transition-colors"
                  [ngClass]="(isEditing && selectedGroupPartyRows && !isAdd ) ? 'bg-green-600 hover:bg-green-700' : 'bg-gray-400 cursor-not-allowed'"
                  (click)="inactivateSelected()" [disabled]="!(isEditing &&selectedGroupPartyRows) ||isAdd">
                  Inactivate
                </button>
              </div>
            </div>
          </form>

          <div class="overflow-x-auto border rounded">
            <table class="w-full text-sm min-w-[600px]">
              <thead class="bg-gray-100 sticky top-0 z-10">
                <tr>
                  <th class="border px-2 py-2 w-10"><input type="checkbox" /></th>
                  <th class="border px-2 py-2">Party ID</th>
                  <th class="border px-2 py-2">Party Name</th>
                  <th class="border px-2 py-2">Group Head</th>
                  <th class="border px-2 py-2">Status</th>
                  <th class="border px-2 py-2">Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let party of groupParties()" [class.bg-green-50]="selectedGroupPartyRows===party">
                  <td class="border px-2 py-1 text-center">
                    <mat-checkbox [checked]="selectedGroupPartyRows===party"
                      (change)="onSingleCheckboxChange(party,$event.checked)" [disabled]="!(isEditing||isAdd)">
                    </mat-checkbox>
                  </td>
                  <td class="border px-2 py-1">{{ party.partiesId }}</td>
                  <td class="border px-2 py-1">{{ party.partiesFullName }}</td>
                  <td class="border px-2 py-1 text-center">
                    <ng-container
                      *ngIf="isAdd || (isEditing && selectedGroupPartyRows===party && party.partyStatus==='Active')||(isEditing && party.transType==='I'); else showGroupHead">
                      <mat-form-field appearance="outline" class="w-full m-0 no-bottom-padding">
                        <mat-select [value]="party.groupHeadStatus"
                          (selectionChange)="onGroupHeadChange(party.partiesId, $event.value)">
                          <mat-option value="Y">Y</mat-option>
                          <mat-option value="N">N</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
                    <ng-template #showGroupHead>{{ party.groupHeadStatus || '-' }}</ng-template>
                  </td>
                  <td class="border px-2 py-1 text-green-600 font-medium">{{ party.partyStatus }}</td>
                  <td class="border px-2 py-1">
                    <ng-container *ngIf="isEditing; else showRemarks">
                      <input type="text" [(ngModel)]="party.gridRemarks" [ngModelOptions]="{standalone: true}"
                        class="w-full px-1 py-1 border rounded" />
                    </ng-container>
                    <ng-template #showRemarks>{{ party.gridRemarks || '-' }}</ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div *ngIf="selectedPartyType === 'GOVT'" class="flex flex-col lg:flex-row w-full gap-4">
        <div class="w-full lg:w-1/3">
          <mat-label class="block mb-1 text-sm font-medium"><span class="text-red-500">*</span>Name</mat-label>
          <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
            <input matInput formControlName="name" />
          </mat-form-field>
        </div>
        <div class="w-full lg:w-1/3">
          <mat-label class="block mb-1 text-sm font-medium">ID Type</mat-label>
          <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
            <mat-select formControlName="idType" (selectionChange)="handleIdTypeChange($event.value)">
              <mat-option *ngFor="let option of idTypes" [value]="option">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- ID Number Input -->
        <div class="w-full lg:w-1/3">
          <mat-label class="block mb-1 text-sm font-medium">
            <span class="text-red-500"
              *ngIf="partyForm.get('idType')?.value?.name?.toLowerCase() !== 'unknown'">*</span> ID Number
          </mat-label>
          <mat-form-field class="w-full" appearance="outline">
            <input matInput formControlName="idNumber" />
            <mat-error
              *ngIf="partyForm.get('idNumber')?.hasError('required') && (partyForm.get('idNumber')?.touched || partyForm.get('idNumber')?.dirty)">
              ID Number is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="p-2 border rounded-lg bg-fieldset mt-2" *ngIf="(partiesData() || isAdd) && selectedPartyType!=='GRP'">

  <div class="relative w-full border-b border-gray-200 mb-4">

    <div *ngIf="showLeftArrow"
      class="absolute left-0 top-0 bottom-0 z-20 flex items-center bg-gradient-to-r from-white via-white to-transparent pr-4 pl-1">
      <button mat-icon-button (click)="scrollTabs('left')"
        class="shadow-sm border bg-white h-8 w-8 !flex !items-center !justify-center">
        <mat-icon class="!text-sm !h-4 !w-4 flex items-center justify-center">chevron_left</mat-icon>
      </button>
    </div>

    <div #tabContainer class="flex items-center overflow-x-auto whitespace-nowrap no-scrollbar scroll-smooth px-2 pb-1"
      (scroll)="checkScroll()" (window:resize)="checkScroll()">

      <div class="tab-buttons flex space-x-6 min-w-max">
        <span class="tab-button" *ngIf="selectedPartyType!=='GRP'" [class.active]="selectedTab === 'idCard'"
          (click)="selectedTab = 'idCard'">ID Card(s)</span>
        <span class="tab-button" *ngIf="selectedPartyType!=='GRP'" [class.active]="selectedTab === 'addresses'"
          (click)="selectedTab = 'addresses'">Addresses</span>
        <span class="tab-button" *ngIf="selectedPartyType!=='GRP'" [class.active]="selectedTab === 'contacts'"
          (click)="selectedTab = 'contacts'">Contacts</span>
        <span class="tab-button" *ngIf="selectedPartyType!=='GRP'" [class.active]="selectedTab === 'previousNames'"
          (click)="selectedTab = 'previousNames'">Previous Names & Aliases</span>
        <span class="tab-button" [class.active]="selectedTab === 'cases'" (click)="selectedTab = 'cases'"
          *ngIf="!isAdd && !currentScreenType">Cases</span>
      </div>
    </div>

    <div *ngIf="showRightArrow"
      class="absolute right-0 top-0 bottom-0 z-20 flex items-center bg-gradient-to-l from-white via-white to-transparent pl-4 pr-1">
      <button mat-icon-button (click)="scrollTabs('right')"
        class="shadow-md border bg-white h-8 w-8 !flex !items-center !justify-center text-primary-600">
        <mat-icon class="!text-sm !h-4 !w-4 flex items-center justify-center font-bold">arrow_forward_ios</mat-icon>
      </button>
    </div>

  </div>

  <div class="table-container" *ngIf="selectedTab==='idCard'">
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
      <h3 class="heading">ID Cards</h3>
      <div class="flex flex-wrap gap-2 action-buttons">
        <button mat-flat-button color="primary" class="action-button" (click)="addIdTypeRow()"
          [disabled]="isDashboard || (!isEditing && !isAdd)">
          <mat-icon>add</mat-icon> Add
        </button>
        <button mat-flat-button color="primary" class="action-button"
          [disabled]="!selectedIdcard || (!isEditing && !isAdd)" (click)="modifySelectedIdCard()"
          *ngIf="!isEditingIdType">
          <mat-icon>edit</mat-icon> Modify
        </button>
        <button *ngIf="isEditingIdType" mat-stroked-button color="warn" class="action-button"
          (click)="onIdCardCancelClick()">
          <mat-icon>cancel</mat-icon> Cancel
        </button>
      </div>
    </div>

    <div class="result-table-container">
      <ng-container *ngIf="!isIDTypeLoading; else loadingSpinner">
        <table mat-table [dataSource]="idTypesList" class="mat-elevation-z8 sticky-table w-full min-w-[600px]">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef style="width: 50px;"></th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox [checked]="selectedIdcard===element"
                (change)="onidCardCheckboxChange(element, $event.checked)"
                [disabled]="(!(isAdd) && isEditingIdType) || isDashboard"></mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="idType">
            <th mat-header-cell *matHeaderCellDef><span style="color: red;">*</span> ID Type</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <ng-container
                *ngIf="element.isNew || (selectedIdcard === element && isEditingIdType); else readonlyIdType">
                <mat-select [(ngModel)]="element.istId" [ngModelOptions]="{ standalone: true }"
                  (selectionChange)="onIdTypeSelected(element); onIdFieldChange(i)"
                  class="w-full px-2 py-1 border border-gray-300 rounded">
                  <mat-option *ngFor="let option of idTypes" [value]="option.id">{{ option.name }}</mat-option>
                </mat-select>
              </ng-container>
              <ng-template #readonlyIdType>{{ element.istName }}</ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="idNumber">
            <th mat-header-cell *matHeaderCellDef><span style="color: red;">*</span> ID Number</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <ng-container
                *ngIf="element.isNew || (selectedIdcard === element && isEditingIdType); else readonlyIdNumber">
                <input matInput [(ngModel)]="element.istValue" [ngModelOptions]="{ standalone: true }"
                  (input)="onIdFieldChange(i)" [readonly]="element.disableIdInput"
                  class="w-full px-2 py-1 border border-gray-300 rounded" />
              </ng-container>
              <ng-template #readonlyIdNumber>{{ element.istValue }}</ng-template>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['select', 'idType', 'idNumber']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['select', 'idType', 'idNumber'];"></tr>
        </table>
      </ng-container>
    </div>
  </div>

  <div class="table-container" *ngIf="selectedTab==='previousNames'">
    <div class="flex flex-col lg:flex-row gap-6">

      <div class="w-full lg:w-1/2">
        <div class="flex justify-between items-center mb-4">
          <h3 class="heading">Previous Names</h3>
          <div class="flex flex-wrap items-center gap-2">
            <button mat-flat-button color="primary" class="action-button" (click)="addPreviousName()"
              [disabled]="isDashboard || (!isEditing && !isAdd)">
              <mat-icon>add</mat-icon> Add</button>
            <button *ngIf="!isPreviousNameEditing" mat-flat-button color="primary" class="action-button"
              [disabled]="!selectedPreviousNameRow || (!isEditing && !isAdd)"
              (click)="onPreviousNameModifyClick()"><mat-icon>edit</mat-icon>
              Modify</button>
            <button *ngIf="isPreviousNameEditing" mat-stroked-button color="warn"
              class="action-button flex items-center gap-1" (click)="onPreviousNameCancelClick()">
              <mat-icon>cancel</mat-icon> Cancel</button>
          </div>
        </div>
        <div class="result-table-container">
          <table mat-table [dataSource]="previousNamesList" class="mat-elevation-z8 sticky-table w-full min-w-[600px]">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef class="w-[50px]"></th>
              <td mat-cell *matCellDef="let row"><mat-checkbox [checked]="selectedPreviousNameRow === row"
                  (change)="onPreviousNameCheckboxChange(row, $event.checked)"
                  [disabled]="(!(isAdd) && isPreviousNameEditing) || isDashboard"></mat-checkbox></td>
            </ng-container>
            <ng-container matColumnDef="partyName">
              <th mat-header-cell *matHeaderCellDef><span class="text-red-500">*</span> Party Name</th>
              <td mat-cell *matCellDef="let row">
                <input *ngIf="(selectedPreviousNameRow === row && isPreviousNameEditing) || row.isNew; else txt"
                  [(ngModel)]="row.name" [ngModelOptions]="{standalone: true}"
                  class="w-full px-2 py-1 border rounded" />
                <ng-template #txt>{{ row.name }}</ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="surname">
              <th mat-header-cell *matHeaderCellDef><span class="text-red-500">*</span> Surname</th>
              <td mat-cell *matCellDef="let row">
                <input *ngIf="(selectedPreviousNameRow === row && isPreviousNameEditing) || row.isNew; else txtSurname"
                  [(ngModel)]="row.familyName" [ngModelOptions]="{standalone: true}"
                  class="w-full px-2 py-1 border rounded" />
                <ng-template #txtSurname>{{ row.familyName }}</ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="validUntil">
              <th mat-header-cell *matHeaderCellDef><span class="text-red-500">*</span> Valid Until</th>
              <td mat-cell *matCellDef="let row">
                <input type="date"
                  *ngIf="(selectedPreviousNameRow === row && isPreviousNameEditing) || row.isNew; else txtDate"
                  [ngModel]="toDateInputFormat(row.validUntil)"
                  (ngModelChange)="row.validUntil = $event; row.isEdited = true" [ngModelOptions]="{standalone: true}"
                  class="w-full px-2 py-1 border rounded" />
                <ng-template #txtDate>{{ row.validUntil | date: 'yyyy-MM-dd' }}</ng-template>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="['select', 'partyName', 'surname', 'validUntil']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['select', 'partyName', 'surname', 'validUntil'];"></tr>
          </table>
        </div>
      </div>

      <div class="w-full lg:w-1/2">
        <div class="flex justify-between items-center mb-4">
          <h3 class="heading">Aliases</h3>
          <div class="flex flex-wrap items-center gap-2">
            <button mat-flat-button color="primary" class="action-button" (click)="addAlias()"
              [disabled]="isDashboard || (!isEditing && !isAdd)"><mat-icon>add</mat-icon> Add</button>
            <button *ngIf="!isAliasEditing" mat-flat-button color="primary" class="action-button"
              [disabled]="!selectedAliasRow || (!isEditing && !isAdd)"
              (click)="onAliasModifyClick()"><mat-icon>edit</mat-icon> Modify</button>
            <button *ngIf="isAliasEditing" mat-stroked-button color="warn" class="action-button flex items-center gap-1"
              (click)="onAliasNameCancelClick()">
              <mat-icon>cancel</mat-icon> Cancel</button>
          </div>
        </div>
        <div class="result-table-container">
          <table mat-table [dataSource]="aliasesList" class="mat-elevation-z8 sticky-table w-full min-w-[300px]">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef class="w-[50px]"></th>
              <td mat-cell *matCellDef="let row"><mat-checkbox [checked]="selectedAliasRow === row"
                  (change)="onAliasCheckboxChange(row, $event.checked)"
                  [disabled]="(!(isAdd) && isAliasEditing) || isDashboard"></mat-checkbox></td>
            </ng-container>
            <ng-container matColumnDef="aliasName">
              <th mat-header-cell *matHeaderCellDef><span class="text-red-500">*</span> Alias Name</th>
              <td mat-cell *matCellDef="let row">
                <input *ngIf="(selectedAliasRow === row && isAliasEditing) || row.isNew; else txtAlias"
                  [(ngModel)]="row.aliasName" [ngModelOptions]="{standalone: true}"
                  class="w-full px-2 py-1 border rounded" />
                <ng-template #txtAlias>{{ row.aliasName }}</ng-template>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="['select', 'aliasName']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['select', 'aliasName'];"></tr>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="table-container" *ngIf="selectedTab==='cases'&&isAdd===false && !currentScreenType">
    <div class="flex justify-between items-center mb-4">
      <h3 class="heading">Cases</h3>
    </div>
    <div class="result-table-container">
      <table mat-table [dataSource]="partiesData()?.casPhPrtRolesData||[]"
        class="mat-elevation-z8 sticky-table w-full min-w-[800px]">
        <ng-container matColumnDef="caseNumber">
          <th mat-header-cell *matHeaderCellDef>Case Number</th>
          <td mat-cell *matCellDef="let element">{{ element.caseNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="casePhaseCaseId">
          <th mat-header-cell *matHeaderCellDef>Case Phase - Case ID</th>
          <td mat-cell *matCellDef="let element">{{ element.casePhaseCaseId }}</td>
        </ng-container>
        <ng-container matColumnDef="casePhaseId">
          <th mat-header-cell *matHeaderCellDef>Case Phase ID</th>
          <td mat-cell *matCellDef="let element">{{ element.casePhaseId }}</td>
        </ng-container>
        <ng-container matColumnDef="beginDate">
          <th mat-header-cell *matHeaderCellDef>Begin Date</th>
          <td mat-cell *matCellDef="let element">{{ element.beginDate | date: 'yyyy-MM-dd' }}</td>
        </ng-container>
        <ng-container matColumnDef="endDate">
          <th mat-header-cell *matHeaderCellDef>End Date</th>
          <td mat-cell *matCellDef="let element">{{ element.endDate ? (element.endDate | date: 'yyyy-MM-dd') : '-' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="partyRoleId">
          <th mat-header-cell *matHeaderCellDef>Party Role ID</th>
          <td mat-cell *matCellDef="let element">{{ element.partyRoleId }}</td>
        </ng-container>
        <ng-container matColumnDef="partyRoleName">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.partyRoleName }}</td>
        </ng-container>
        <tr mat-header-row
          *matHeaderRowDef="['caseNumber', 'casePhaseCaseId', 'casePhaseId', 'beginDate', 'endDate', 'partyRoleId', 'partyRoleName']">
        </tr>
        <tr mat-row
          *matRowDef="let row; columns: ['caseNumber', 'casePhaseCaseId', 'casePhaseId', 'beginDate', 'endDate', 'partyRoleId', 'partyRoleName'];">
        </tr>
      </table>
    </div>
  </div>

  <div class="table-container" *ngIf="selectedTab === 'contacts'">
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
      <h3 class="heading">Contacts</h3>
      <div class="flex flex-wrap gap-2 action-buttons">
        <button mat-flat-button color="primary" class="action-button" (click)="addContactRow()"
          [disabled]="isDashboard || (!isEditing && !isAdd)">
          <mat-icon>add</mat-icon> Add
        </button>
        <button *ngIf="!isEditingContact" mat-flat-button color="primary" class="action-button"
          [disabled]="!selectedContact || (!isEditing && !isAdd)" (click)="onModifyContactClick()">
          <mat-icon>edit</mat-icon> Modify
        </button>
        <button *ngIf="isEditingContact" mat-stroked-button color="warn" class="action-button"
          (click)="onCancelContactClick()">
          <mat-icon>cancel</mat-icon> Cancel
        </button>
      </div>
    </div>
    <div class="result-table-container">
      <ng-container *ngIf="!isLoadingContacts; else loadingSpinner">
        <table mat-table [dataSource]="contactsList" class="mat-elevation-z8 sticky-table w-full min-w-[900px]">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="w-[50px]"></th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox [checked]="selectedContact === element"
                (change)="onContactCheckboxChange(element, $event.checked)"
                [disabled]="(!(isAdd) && isEditingContact)|| isDashboard"></mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="seq">
            <th mat-header-cell *matHeaderCellDef class="w-[50px]">Seq</th>
            <td mat-cell *matCellDef="let row">{{ row.seq }}</td>
          </ng-container>
          <ng-container matColumnDef="contactType">
            <th mat-header-cell *matHeaderCellDef><span class="text-red-500">*</span> Contact Type</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <ng-container *ngIf="element.isNew; else readonlyContactType">
                <mat-select [(ngModel)]="element.contactInfoTypesId" [ngModelOptions]="{ standalone: true }"
                  (selectionChange)="oncontactTypeSelected(element); onContactFieldChange(i)"
                  [disabled]="element.isEdited" class="w-full px-2 py-1 border rounded">
                  <mat-option *ngFor="let option of contactTypes" [value]="option.id">{{ option.name }}</mat-option>
                </mat-select>
              </ng-container>
              <ng-template #readonlyContactType>{{ element.contactInfoTypesName }}</ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="contactDetails">
            <th mat-header-cell *matHeaderCellDef><span class="text-red-500">*</span> Contact Details</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <ng-container
                *ngIf="element.isNew || (selectedContact === element && isEditingContact); else readonlyContactDetails">
                <input type="text" [(ngModel)]="element.contactData" class="w-full px-2 py-1 border rounded"
                  [ngModelOptions]="{ standalone: true }" />
              </ng-container>
              <ng-template #readonlyContactDetails>{{ element.contactData }}</ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="validFrom">
            <th mat-header-cell *matHeaderCellDef>Valid From</th>
            <td mat-cell *matCellDef="let element">
              <input type="date" *ngIf="element.isNew || (selectedContact === element && isEditingContact); else txtVF"
                [ngModel]="toDateInputFormat(element.validForm)" (ngModelChange)="element.validForm = $event"
                class="w-full px-2 py-1 border rounded" [ngModelOptions]="{ standalone: true }" />
              <ng-template #txtVF>{{ element.validForm | date: 'dd-MMM-yyyy' }}</ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="validUntil">
            <th mat-header-cell *matHeaderCellDef>Valid Until</th>
            <td mat-cell *matCellDef="let element">
              <input type="date" *ngIf="element.isNew || (selectedContact === element && isEditingContact); else txtVU"
                [ngModel]="toDateInputFormat(element.validUntil)" (ngModelChange)="element.validUntil = $event"
                class="w-full px-2 py-1 border rounded" [ngModelOptions]="{ standalone: true }" />
              <ng-template #txtVU>{{ element.validUntil | date: 'dd-MMM-yyyy' }}</ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="remarks">
            <th mat-header-cell *matHeaderCellDef>Remarks</th>
            <td mat-cell *matCellDef="let element">
              <input type="text" *ngIf="element.isNew || (selectedContact === element && isEditingContact); else txtRem"
                [(ngModel)]="element.ctcComment" class="w-full px-2 py-1 border rounded"
                [ngModelOptions]="{ standalone: true }" />
              <ng-template #txtRem>{{ element.ctcComment }}</ng-template>
            </td>
          </ng-container>
          <tr mat-header-row
            *matHeaderRowDef="['select', 'seq', 'contactType', 'contactDetails', 'validFrom', 'validUntil', 'remarks']">
          </tr>
          <tr mat-row
            *matRowDef="let row; columns: ['select', 'seq', 'contactType', 'contactDetails', 'validFrom', 'validUntil', 'remarks'];">
          </tr>
        </table>
      </ng-container>
    </div>
  </div>

  <div class="table-container" *ngIf="selectedTab === 'addresses'">
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
      <h3 class="heading">Addresses</h3>
      <div class="flex flex-wrap gap-2 action-buttons">
        <button mat-flat-button color="primary" (click)="addAddressRow()"
          [disabled]="isDashboard || (!isEditing && !isAdd)">
          <mat-icon>add</mat-icon> Add</button>
        <button *ngIf="!isEditingAddress" mat-flat-button color="primary"
          [disabled]="!selectedAddress || (!isEditing && !isAdd)"
          (click)="onModifyAddressClick()"><mat-icon>edit</mat-icon> Modify</button>
        <button *ngIf="isEditingAddress" mat-stroked-button color="warn"
          (click)="onCancelAddressClick()"><mat-icon>cancel</mat-icon> Cancel</button>
      </div>
    </div>
    <div class="result-table-container">
      <table mat-table [dataSource]="addressList" class="mat-elevation-z8 sticky-table w-full min-w-[1200px]">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef [style.width.%]="4"></th>
          <td mat-cell *matCellDef="let row"><mat-checkbox [checked]="selectedAddress === row"
              (change)="onAddressCheckboxChange(row, $event.checked)"
              [disabled]="(!(isAdd) && isEditingAddress)|| isDashboard"></mat-checkbox></td>
        </ng-container>
        <ng-container matColumnDef="seq">
          <th mat-header-cell *matHeaderCellDef [style.width.%]="4">Seq</th>
          <td mat-cell *matCellDef="let row">{{ row.seq }}</td>
        </ng-container>
        <ng-container matColumnDef="currentMailTo">
          <th mat-header-cell *matHeaderCellDef [style.width.%]="8">Current Address</th>
          <td mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.currentMailTo === 'D'"
              [disabled]="!(row.isNew || (selectedAddress === row && isEditingAddress))"
              (change)="row.currentMailTo = $event.checked ? 'D' : 'N'"></mat-checkbox></td>
        </ng-container>
        <ng-container matColumnDef="subsidaryDescription">
          <th mat-header-cell *matHeaderCellDef [style.width.%]="12">Address</th>
          <td mat-cell *matCellDef="let row">
            <input *ngIf="row.isNew || (selectedAddress === row && isEditingAddress); else txtAddr" type="text"
              [(ngModel)]="row.subsidaryDescription" [ngModelOptions]="{standalone: true}"
              class="w-full px-2 py-1 border rounded" />
            <ng-template #txtAddr>{{ row.subsidaryDescription }}</ng-template>
          </td>
        </ng-container>
        <ng-container matColumnDef="streetNo">
          <th mat-header-cell *matHeaderCellDef [style.width.%]="8">Street No.</th>
          <td mat-cell *matCellDef="let row">
            <input *ngIf="row.isNew || (selectedAddress === row && isEditingAddress); else txtStNo" type="text"
              [(ngModel)]="row.streetNo" [ngModelOptions]="{standalone: true}"
              class="w-full px-2 py-1 border rounded" />
            <ng-template #txtStNo>{{ row.streetNo }}</ng-template>
          </td>
        </ng-container>
        <ng-container matColumnDef="street">
          <th mat-header-cell *matHeaderCellDef [style.width.%]="8">Street</th>
          <td mat-cell *matCellDef="let row">
            <input *ngIf="row.isNew || (selectedAddress === row && isEditingAddress); else txtSt" type="text"
              [(ngModel)]="row.street" [ngModelOptions]="{standalone: true}" class="w-full px-2 py-1 border rounded" />
            <ng-template #txtSt>{{ row.street }}</ng-template>
          </td>
        </ng-container>
        <ng-container matColumnDef="adminUnitsByAmuIdCountry">
          <th mat-header-cell *matHeaderCellDef [style.width.%]="10"><span class="text-red-500">*</span> Country</th>
          <td mat-cell *matCellDef="let row">
            <mat-select *ngIf="row.isNew; else txtCtry" [(ngModel)]="row.adminUnitsByAmuIdCountryId"
              [ngModelOptions]="{standalone: true}" (selectionChange)="onCountrySelected(row, $event.value)"
              class="w-full px-2 py-1 border rounded">
              <mat-option *ngFor="let country of countryList" [value]="country.id">{{ country.name }}</mat-option>
            </mat-select>
            <ng-template #txtCtry>{{ row.adminUnitsByAmuIdCountry}}</ng-template>
          </td>
        </ng-container>
        <ng-container matColumnDef="adminUnitsByAmuIdPlace">
          <th mat-header-cell *matHeaderCellDef [style.width.%]="10"><span class="text-red-500">*</span> State</th>
          <td mat-cell *matCellDef="let row">
            <mat-select *ngIf="row.isNew; else txtState" [(ngModel)]="row.adminUnitsByAmuIdPlaceId"
              [ngModelOptions]="{standalone: true}" (selectionChange)="onStateSelected(row, $event.value)"
              class="w-full px-2 py-1 border rounded">
              <mat-option *ngFor="let state of stateList" [value]="state.id">{{ state.name }}</mat-option>
            </mat-select>
            <ng-template #txtState>{{ row.adminUnitsByAmuIdPlace}}</ng-template>
          </td>
        </ng-container>
        <ng-container matColumnDef="validForm">
          <th mat-header-cell *matHeaderCellDef [style.width.%]="10">Valid From</th>
          <td mat-cell *matCellDef="let row">
            <input *ngIf="row.isNew || (selectedAddress === row && isEditingAddress); else txtVFAddr" type="date"
              [ngModel]="toDateInputFormat(row.validForm)" [ngModelOptions]="{standalone: true}"
              class="w-full px-2 py-1 border rounded" />
            <ng-template #txtVFAddr>{{ row.validForm | date: 'dd-MMM-yyyy' }}</ng-template>
          </td>
        </ng-container>
        <ng-container matColumnDef="validUntil">
          <th mat-header-cell *matHeaderCellDef [style.width.%]="10">Valid Until</th>
          <td mat-cell *matCellDef="let row">
            <input *ngIf="row.isNew || (selectedAddress === row && isEditingAddress); else txtVUAddr" type="date"
              [ngModel]="toDateInputFormat(row.validUntil)" [ngModelOptions]="{standalone: true}"
              class="w-full px-2 py-1 border rounded" />
            <ng-template #txtVUAddr>{{ row.validUntil | date: 'dd-MMM-yyyy' }}</ng-template>
          </td>
        </ng-container>
        <ng-container matColumnDef="adrComment">
          <th mat-header-cell *matHeaderCellDef [style.width.%]="12">Remarks</th>
          <td mat-cell *matCellDef="let row">
            <input *ngIf="row.isNew || (selectedAddress === row && isEditingAddress); else txtRemAddr" type="text"
              [(ngModel)]="row.adrComment" [ngModelOptions]="{standalone: true}"
              class="w-full px-2 py-1 border rounded" />
            <ng-template #txtRemAddr>{{ row.adrComment }}</ng-template>
          </td>
        </ng-container>
        <tr mat-header-row
          *matHeaderRowDef="['select', 'seq', 'currentMailTo', 'subsidaryDescription', 'streetNo', 'street', 'adminUnitsByAmuIdCountry', 'adminUnitsByAmuIdPlace', 'validForm', 'validUntil', 'adrComment']">
        </tr>
        <tr mat-row
          *matRowDef="let row; columns: ['select', 'seq', 'currentMailTo', 'subsidaryDescription', 'streetNo', 'street', 'adminUnitsByAmuIdCountry', 'adminUnitsByAmuIdPlace', 'validForm', 'validUntil', 'adrComment'];">
        </tr>
      </table>
    </div>
  </div>

  <ng-template #loadingSpinner>
    <div class="flex justify-center items-center h-full p-6">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>
  </ng-template>

</div>